import { useSelector } from "react-redux";

import { selectContactsCost, selectRemainingQuota } from "../store/selectors";

const useRemainingRevealCredits = (): number => {
    const remainingRevealQuota = useSelector(selectRemainingQuota);
    const contactsCost = useSelector(selectContactsCost);

    return contactsCost > 0 ? Math.floor(remainingRevealQuota / contactsCost) : 0;
};

export default useRemainingRevealCredits;
